<template>
  <div class="security-code">
    <CommonContent>
      <div class="search-box">
        <input v-model="value" class="search-input" placeholder="请输入防伪码" />
      </div>
      <div class="search-btn" @click="handleSearch">
        查&nbsp;询
      </div>
      <div class="tip">
        <!-- <div class="item left">
          <div class="desc">
            <p>刮开防伪标签</p>
            <p>上的灰色涂层</p>
          </div>
          <img src="~images/right-icon.svg" />
        </div>
        <div class="line">
        </div>
        <div class="item mid">
          <div class="desc">
            输入12位防伪码
          </div>
          <img src="~images/right-icon.svg" />
        </div>
        <div class="line">
        </div>
        <div class="item right">
          <div class="desc">
            点击查询按钮
          </div>
          <img src="~images/right-icon.svg" />
        </div> -->
      </div>
      <div v-if="loading" class="result-desc">
        <Loading />
      </div>
      <div v-if="!loading && !hasResult" class="result-desc">
        <div class="content">
          <p class="first-line">
            查询显示结果如下：
          </p>
          <p> 1.如果错误，提示为“您输入的防伪码不存在，谨防假冒”。</p>
          <p> 2.如查询过，提示“该商品已经被查询过，本次是第*次查询，谨防假冒”。</p>
        </div>
      </div>
      <div v-if="!loading && hasResult" class="result-desc">
        <div class="content">
          <div class="title">
            查询结果
          </div>
          <div v-if="isTrue">
            <p v-if="searchNum * 1 !== 0">
              该商品已经被查询过，本次是第<span class="num">{{ searchNum * 1 + 1 }}</span>次查询，上一次查询时间：{{ searchTime }}，查询IP：{{ searchIp }}，如本次查验是您第一次操作，谨防假冒。
            </p>
            <p v-else>
              该商品为首次查询，请谨防假冒。
            </p>
          </div>
          <div v-if="!isTrue">
            <p>您输入的防伪码{{ searchValue }}<span class="highlight">不存在</span>，谨防假冒。</p>
          </div>
        </div>
      </div>
    </CommonContent>
  </div>
</template>

<script>
import Loading from '@/components/Loading'
import CommonContent from '@/components/CommonContent.vue'
import { querySecurityCode } from '@/api/common'

export default {
  name: 'SecurityCode',
  components: {
    CommonContent,
    Loading
  },
  data() {
    return {
      value: '',
      loading: false,
      hasResult: false,
      isTrue: false,
      searchValue: '',
      searchNum: null,
      searchTime: '',
      searchIp: ''
    }
  },
  watch: {
    value(newVal) {
      if (!newVal) {
        this.hasResult = false
      }
    }
  },
  methods: {
    handleSearch() {
      if (!this.value) return
      this.hasResult = false
      this.loading = true
      this.searchValue = this.value
      querySecurityCode(this.value).then(res => {
        let { success, errorType, content } = res.data
        if (success && errorType === '00000000') {
          this.hasResult = true
          const { queryCount, lastQueryTime, queryIp } = content
          this.isTrue = queryCount !== '-1'
          this.searchTime = lastQueryTime || '--'
          this.searchNum = queryCount
          this.searchIp = queryIp || '--'
        } else {
          this.hasResult = false
          alert('查询失败，请稍后再试！')
        }
        this.loading = false
      }).catch(() => {
        this.hasResult = false
        this.loading = false
        alert('查询失败，请稍后再试！')
      })
    }
  }
}
</script>

<style lang="less" scopeds>
.security-code{
  width: 100%;
  height: 100%;
  .search-box{
    width: 590px;
    height: 100px;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(180deg, #659BF6 0%, #3E67F4 100%);
    border-radius: 10px;
    .search-input{
      width: 570px;
      height: 80px;
      background: #FFFFFF;
      border-radius: 10px;
      border: 0;
      padding: 0 32px;
      box-sizing: border-box;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #4389F2;
    }
  }
  .search-btn{
    margin: 15px auto 60px;
    width: 205px;
    height: 85px;
    text-align: center;
    line-height: 75px;
    background: url('~images/search-btn.png') no-repeat left top;
    background-size: 100% 100%;
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: 700;
    color: #FFFFFF;
    -webkit-text-stroke: 2px #4EA3F3;
  }
  .tip{
      width: 690px;
      height: 108px;
      margin: auto;
      // background: linear-gradient(-1deg, #789EF5, #6F98F3, #9AC3FF);
      border-radius: 14px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: url('~images/security-code.png') left top;
      background-size: 100% 100%;
      .item{
        height: 100%;
        display: flex;
        align-items: center;
        &.left{
          width: 227px;
          padding-left: 15px;
          box-sizing: border-box;
        }
        &.mid{
          width: 249px;
          padding-left: 15px;
          box-sizing: border-box;
        }
        &.right{
          flex: 1;
          padding-left: 9px;
          box-sizing: border-box;
        }
        .desc{
          font-size: 28px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
          margin-right: 6px;
        }
        img{
          width: 24px;
          margin-top: 5px;
        }
      }
      .line{
        width: 1px;
        height: 50px;
        background: #91B8FE;
      }
  }
  .result-desc{
    width: 623px;
    height: 288px;
    margin: 35px auto 180px;
    background: rgba(149, 191, 254, 0.33);
    border-radius: 10px;
    display: flex;
    justify-content: center;
    .content{
      .first-line{
        margin-top: 30px;
      }
      padding: 0 40px;
      box-sizing: border-box;
      .title{
        padding: 0;
        height: 80px;
        line-height: 80px;
        font-size: 26px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
      }
      p{
        font-size: 26px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.8);
        line-height: 44px;
        word-break: break-all;
        >.num{
          font-size: 32px;
          color: #F6FE12;
          margin: 0 10px;
        }
        >.highlight{
          font-size: 30px;
          color: #F6FE12;
        }
      }
    }
  }
}
</style>
